import React from 'react'

const OurTeam = () => {
  return (
    <div>
      
    </div>
  )
}

export default OurTeam
